var exports = {
  "iE": "x31de4314--cc35ef--wrapper",
  "tX": "x31de4314--cc35ef--title-container",
  "x6": "x31de4314--cc35ef--button",
  "TW": "x31de4314--cc35ef--villages-list",
};

module.exports = exports;
